import styled from "styled-components";

import * as Dropdown from "ds/Dropdown";
import * as Radio from "ds/Radio";
import Skeleton from "src/organization/pages/project/environment/metrics/containers/Service/LargeMetric/LargeMetric.skeleton";
import HttpLayout from "src/organization/pages/project/environment/metrics/http/components/HttpLayout";
import {
  RequestBandWidthContainer,
  RequestWrapper,
  ChartTitleList
} from "src/organization/pages/project/environment/metrics/http/style";
import * as S from "src/organization/pages/project/environment/metrics/http/style";

export const CpuTotalContainer = styled(RequestWrapper)``;

export const TitleContainer = styled(S.ChartTitleContainer)`
  margin-bottom: 7px;
`;

export const TitleHeaderContainer = styled(TitleContainer)`
  margin-bottom: 24px;
`;

export const Subtitle = styled(S.ChartTitle)`
  font-weight: 600;
  font-size: 13px;
`;

export const InlineBlock = styled.div`
  display: flex;
  align-items: center;
`;

export const TotalContainer = styled(RequestBandWidthContainer)`
  padding: 24px 32px;
  margin-bottom: 9px;
  display: block;
  .metrics-skeleton {
    flex-grow: 1;
  }
`;

export const TotalChartList = styled(RequestBandWidthContainer)`
  gap: 21px;
  margin: 0;
  padding: 0;
  .divider {
    margin: 7px 10px 7px 10px;
  }
`;

export const RadioGroup = styled(Radio.Group)`
  display: flex;
  flex-direction: column;
  text-transform: capitalize;
`;

export const RadioItem = styled(Dropdown.RadioItem)`
  label {
    font-weight: 400;
    color: var(--header-ebony-color, var(--ebony));
    margin-top: -2px;
  }
`;

export const TotalUnitSkeleton = styled(Skeleton)``;

export const ChartTitle = styled(S.ChartTitle)`
  font-size: 18px;
`;

export const TotalSkeletonContainer = styled(TotalContainer)`
  padding-bottom: 38px;
  .total-unit-list {
    margin-top: 34px;
  }
`;

export const TitleList = styled(ChartTitleList)`
  gap: 14px;
`;

export const AllocationLayout = styled(HttpLayout)``;
